import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import RevenueOpportunityRecipientPresetService from "services/RevenueOpportunityRecipientPreset";

const DeleteRevenueOpportunityRecipientPresetModal = ({
  preset,
  open,
  onOpenChange,
  fetchPresets,
  onSuccess,
}) => {
  const handleConfirm = async () => {
    try {
      await RevenueOpportunityRecipientPresetService.deleteRevenueOpportunityRecipientPreset(
        preset.id
      );
      toast.success("Preset deleted");
      onOpenChange(false);
      if (onSuccess) {
        onSuccess();
      } else if (fetchPresets) {
        fetchPresets();
      }
    } catch {
      toast.error("Failed to delete preset");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete preset?"
      description="Are you sure you want to delete this Recipient Preset?"
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteRevenueOpportunityRecipientPresetModal;
